<template>
  <el-dialog  class="toDevelop_model_dialog" top="5vh" center
              :title="'其他任务-【' + formInfo.id + '】' + formInfo.title" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex">
        <el-form-item label="任务标题" prop="domain" :label-width="formLabelWidth">
          {{ formInfo.title }}
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="任务类型" :label-width="formLabelWidth">
          {{allSelect.OTHERTASHOPERATOR[formInfo.task_type]}}
        </el-form-item>
        <el-form-item label="需求人" label-width="185px">

          {{allSelect.TEXTALLUSERSEN[formInfo.demander]}}
        </el-form-item>
        <el-form-item label="优先级" label-width="185px">
          p1
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="负责人" label-width="120px">
          {{allSelect.TEXTALLUSERSEN[formInfo.leading]}}
        </el-form-item>
        <el-form-item label="计划开始日期" label-width="120px">
          {{ formatTimeToDate(formInfo.plt * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item label="计划完成时间" label-width="160px">
          {{ formatTimeToDate(formInfo.plet * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
      </div>
      <div style="display: flex;">
      <el-form-item label="状态" label-width="110px">
        {{ allSelect.OTHERTASKSTATUS[formInfo.status] }}
      </el-form-item>
      <el-form-item label="创建人" label-width="190px">

        {{allSelect.TEXTALLUSERSEN[formInfo.username]}}
      </el-form-item>
      <el-form-item label="创建时间" label-width="170px">
        {{ formatTimeToDate(formInfo.create_time * 1, "YYYY-MM-DD HH:mm:ss") }}
      </el-form-item>
      </div>
      <el-form :model="formInfo" v-if="formInfo.id">
        <el-form-item class="comment_warp" label="评论" :model="formInfo" :label-width="formLabelWidth">
          <Comment  :tid="String(formInfo.id)" type="other_task" />
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="warning" :loading="loading.submit" @click="submit">开 始</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  postDevOpsSpaceUpdateOtherTaskApi,
  getDevOpsSpaceOtherDetailApi
} from "@/server/tops/devOps";
import { formatStrToArr, formatTimeToDate } from "@/views/tops/devOps/components/util.js"
import {mapState} from "vuex";
import Comment from '@/views/tops/devOps/producerSpace/components/comment.vue'
export default {
  components: {Comment},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        id: ''
      },
      rules: {
      },
      formLabelWidth: '130px',
      loading: {
        submit: false,
        dialog: true
      },
    };
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
  },
  async created() {
    await this.getOtherDetailApi();
  },
  methods: {
    // 获取详情
    async getOtherDetailApi() {
      const { id = "" } = this.formInfo || {};
      try {
        const ret = await getDevOpsSpaceOtherDetailApi({
          id: id,
        });
        const info = ret.data[0] || {};
        this.formInfo = {
          ...this.formInfo,
          demander: info.demander,
          creator: info.username,
          title: info.title,
          task_type: info.task_type,
          status: info.status,
          project_system: info.project_system,
          priority: info.priority,
          plt: info.plt,
          plet: info.plet,
          operator_context: info.operator_context,
          leading: info.leading,
          context: info.context,
          create_time: info.create_time,
        };
      } catch (error) {
        this.$notify({
          message: error || "获取详情失败",
          type: "error",
        });
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 开始
    async submit() {
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          try {
            const { id='', leading='' } = this.formInfo;
            let param = {
               id: id,
              'flag':'edit_status',
              'username' : username,
              'leading':leading,
            };
            this.loading.submit = true;
            const ret = await postDevOpsSpaceUpdateOtherTaskApi(param);
            if (ret.status === 'success') {
              this.handleClose('to_be_submitted');
            } else {
              this.$notify({
                message: ret.data?.msg || "开始失败",
                type: "error",
              });
            }
          } catch (error) {
            this.$notify({
              message: 'error' || "代码报错",
              type: "error",
            });
          }
          finally {
            this.loading.submit = false;
          }

    },
    formatTimeToDate
  }
};
</script>
<style lang="scss">
.toDevelop_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
.el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
  line-height: 16px;
}
</style>